const SENSITIVE_QUERY_PARAMETER =
  /(^|[?&#])((?:surveyToken|ucode|token)=)[^&#\s]*/giu;
const SENSITIVE_JSON_FIELD =
  /("(?:surveyToken|ucode|token|accessToken|authorization)"\s*:\s*")((?:\\.|[^"\\])*)"/giu;
const BEARER_CREDENTIAL = /(\bBearer\s+)[^\s"',}\]]+/giu;
const SENSITIVE_FIELD_NAMES = new Set([
  "surveytoken",
  "ucode",
  "token",
  "accesstoken",
  "authorization",
]);

function redactSensitiveString(value: string): string {
  return redactSensitiveQueryParameters(value)
    .replace(SENSITIVE_JSON_FIELD, '$1[REDACTED]"')
    .replace(BEARER_CREDENTIAL, "$1[REDACTED]");
}

export function redactSensitiveQueryParameters(value: string): string {
  return value.replace(
    SENSITIVE_QUERY_PARAMETER,
    (_match, prefix: string, parameter: string) =>
      `${prefix}${parameter}[REDACTED]`,
  );
}

function redactSensitiveValue(value: unknown, visited: WeakSet<object>): void {
  if (!value || typeof value !== "object" || visited.has(value)) return;
  visited.add(value);

  if (Array.isArray(value)) {
    for (let index = 0; index < value.length; index += 1) {
      const item = value[index];
      if (typeof item === "string") {
        value[index] = redactSensitiveString(item);
      } else {
        redactSensitiveValue(item, visited);
      }
    }
    return;
  }

  const record = value as Record<string, unknown>;
  for (const [key, item] of Object.entries(record)) {
    if (SENSITIVE_FIELD_NAMES.has(key.toLowerCase())) {
      record[key] = "[REDACTED]";
    } else if (typeof item === "string") {
      record[key] = redactSensitiveString(item);
    } else {
      redactSensitiveValue(item, visited);
    }
  }
}

export function redactSensitiveEvent<T>(event: T): T {
  redactSensitiveValue(event, new WeakSet<object>());
  return event;
}
